export default __webpack_public_path__ + "static/media/hands-gesture-star.be42d115.svg";